module.exports = __webpack_public_path__ + "img/img_chongshenka2@2x.a19fb101.png";